
import { Link } from "react-router-dom";

const ButtonType2 = ({type, title, onClick, href, className}) => {
    return (
        <>
            {type === 'link' ? (
                <Link to = {href} className = {`button2 text-[#BCBCBC] text-white rounded-[16px] uppercase tracking-[1.5px] flex justify-center items-center ${className}`}
                    style = {{background: 'linear-gradient(103.91deg, #9B51E0 21.01%, rgba(48, 129, 237, 0.8) 100%)'}}
                >
                    {title}
                </Link>    
            ):(
                <button onClick={onClick} className = {`button2 text-[#BCBCBC] text-white rounded-[16px] uppercase tracking-[1.5px] justify-center items-center ${className}`}
                    style = {{background: 'linear-gradient(103.91deg, #9B51E0 21.01%, rgba(48, 129, 237, 0.8) 100%)'}}
                >
                    {title}
                </button>
            )}
        </>
    )
}

export default ButtonType2;